module.exports = __webpack_public_path__ + "img/middle_son.f04e7d07.png";